<template>
  <div class="develop" data-aos="fade-in">
    <div class="bg-box">
      <div class="txt">
        <h2 class="planh1">
          {{ $t("doc.t1") }}
        </h2>

        <p class="planp">
          {{ $t("doc.t2") }}
        </p>
        <div class="content-container item-warpper">
          <div class="item-content">
            <p>{{ $t("doc.dailyOutput") }}</p>
            <p class="number-content">
              {{ developer.inFo.dailyOutput }} <span>mLAMB</span>
            </p>
            <p>{{ $t("doc.about") }}{{ developer.inFo.dailyConvert }}LAMB</p>
            <a
              target="_blank"
              href="https://download.lambdastorage.com/lambda-storage/0.3.3/lambda-storage-0.3.3.tar.gz"
            >{{ $t("doc.btn3") }}</a>
          </div>
          <div class="item-content">
            <p>{{ $t("doc.totalCapacity") }}</p>
            <p class="number-content">
              {{ developer.inFo.totalCapacity }} <span>PB</span>
            </p>
            <p class="nbsp">
              &nbsp;&nbsp;
            </p>
            <a target="_blank" href="http://docs.lambda.im">{{
              $t("doc.btn1")
            }}</a>
          </div>
          <div class="item-content">
            <p>{{ $t("doc.totalPower") }}</p>
            <p class="number-content">
              {{ developer.inFo.totalPower }} <span>PB</span>
            </p>
            <p class="nbsp">
              &nbsp;&nbsp;
            </p>
            <a target="_blank" href="https://discord.gg/AHgeaf3d">{{
              $t("doc.btn2")
            }}</a>
          </div>
        </div>
        <!-- <a-row style="line-height: 65px;margin: 0 auto;">
          <a-col :md="24" :lg="12" :xl="8" :sm="24">
            <myButton
              customType="link"
              href="https://github.com/LambdaIM"
              borderColor="#fff"
              >{{ $t("doc.btn3") }}</myButton
            >
          </a-col>
          <a-col :md="24" :lg="12" :xl="8" :sm="24">
            <myButton
              customType="link"
              href="http://docs.lambda.im"
              bgc="transparent"
              borderColor="#fff"
              color="#fff"
            >
              {{ $t("doc.btn1") }}
            </myButton>
          </a-col>
          <a-col :md="24" :lg="12" :xl="8" :sm="24">
            <myButton
              customType="link"
              href="https://discord.gg/AHgeaf3d"
              borderColor="#fff"
            >
              {{ $t("doc.btn2") }}
            </myButton>
          </a-col>
        </a-row> -->
      </div>
    </div>

    <div class="content-container">
      <div class="mining-title">
        <p>
          <span>{{ $t("doc.farmingLand") }}</span>
        </p>
        <h6>
          {{ $t("doc.titleH1") }}
        </h6>
      </div>
      <div class="mining-content">
        <div class="way1-warpper">
          <div class="top-content">
            <div>
              <img src="../../assets/develop/$-y.svg" alt="$-y">
            </div>
            <div>
              <p>
                {{ $t("doc.reserve") }}：{{ developer.inFo.reserve }}mLAMB（{{
                  $t("doc.reserveConvert")
                }}{{ developer.inFo.reserveConvert }}LAMB）
              </p>
              <div class="p-box">
                <p class="mr-20">
                  {{ $t("doc.reserveIncome") }}
                </p>
                <p>{{ developer.inFo.reserveIncome }}mLAMB/天</p>
              </div>
              <p>
                {{ $t("doc.provide1") }}{{ developer.inFo.provide }}mLAMB{{
                  $t("doc.provide2")
                }}
              </p>
            </div>
          </div>
          <div class="link-item">
            <a href="https://www.lambswap.fi/#/exchange" target="_blank">{{
              $t("doc.provide3")
            }}</a>
            <img src="../../assets/develop/arrow-y.svg" alt="arrow-y">
          </div>
        </div>
        <div class="way1-warpper">
          <div class="top-content">
            <div>
              <img src="../../assets/develop/computer-b.svg" alt="computer">
            </div>
            <div>
              <p>
                {{ $t("doc.totalComputingPower") }}：{{
                  developer.inFo.totalComputingPower
                }}PB
              </p>
              <div class="p-box">
                <p class="mr-20">
                  {{ $t("doc.computingPower") }}
                </p>
                <p>{{ developer.inFo.computingPower }} mLAMB/T</p>
              </div>
              <p class="nbsp">
                &nbsp;
              </p>
            </div>
          </div>
          <div class="link-item">
            <a
              href="http://docs.lambda.im/Farming-Operation-Guide/"
              target="_blank"
            >{{ $t("doc.computingPower1") }}</a>
            <img src="../../assets/develop/arrow-b.svg" alt="arrow-b">
          </div>
        </div>
      </div>
    </div>
    <div class="content-container">
      <div class="mining-title">
        <p>
          <span>{{ $t("doc.Mining") }}</span>
        </p>
        <h6>
          {{ $t("doc.Mining4") }}
        </h6>
      </div>
      <div class="mining-content">
        <div class="way2-warpper">
          <img src="../../assets/develop/computer-b.svg" alt="computer">
          <p>
            {{ $t("doc.computingPower") }}
          </p>
          <div>
            <p>{{ developer.inFo.pledge }} mLAMB/T</p>
            <span>{{ $t("doc.Mining1") }}10000mLAMB/T{{ $t("doc.Mining2") }}</span>
          </div>
          <div class="link-item">
            <a
              href="http://docs.lambda.im/Lambda-Store-and-Mining/"
              target="_blank"
            >{{ $t("doc.Mining3") }}</a>
            <img src="../../assets/develop/arrow-b.svg" alt="arrow-b">
          </div>
        </div>
      </div>
    </div>

    <div class="content-container work-content">
      <div class="flex-content">
        <div class="circle">
          <img src="../../assets/develop/mlamb48.svg" alt="mlamb48">
        </div>
        <div>
          <h2>{{ $t("doc.works") }}</h2>
          <p>{{ $t("doc.works1") }}</p>
          <p>{{ $t("doc.works2") }}</p>
          <p>{{ $t("doc.works3") }}</p>
        </div>
      </div>
      <div class="link-item">
        <a href="https://www.lambswap.fi/#/exchange" target="_blank">{{
          $t("doc.works4")
        }}</a>
        <img src="../../assets/develop/arrow-b.svg" alt="arrow-b">
      </div>
    </div>

    <div class="link-container content-container">
      <h3>{{ $t("doc.l1") }}</h3>
      <div class="link-wrapper">
        <myButton
          class="link-button"
          custom-type="link"
          href="http://explorer.lambdastorage.com/#/"
        >
          {{ $t("doc.btn.b1") }}
        </myButton>
        <myButton
          class="link-button"
          custom-type="link"
          href="http://stats.lambdastorage.com/"
        >
          {{ $t("doc.btn.b2") }}
        </myButton>
        <myButton
          class="link-button"
          custom-type="link"
          href="http://s3.oneweb.one/minio/login"
        >
          {{ $t("doc.btn.b3") }}
        </myButton>
      </div>
    </div>

    <div class="content-container dappTitle txtcenter">
      <h3>{{ $t("doc.h3") }}</h3>
    </div>
    <div class="content-container dapp txtcenter ">
      <h4>{{ $t("doc.s1.h4") }}</h4>
      <div class="section-wrapper">
        <div class="section-item">
          <div class="imgitem">
            <img :src="require('@/assets/develop/Nintendo swich.png')">
          </div>
          <h5>{{ $t("doc.s1.s1.t1") }}</h5>
          <span>{{ $t("doc.s1.s1.t2") }}</span>
        </div>
        <div class="section-item">
          <div class="imgitem">
            <img :src="require('@/assets/develop/Credit cards 2.png')">
          </div>
          <h5>{{ $t("doc.s1.s2.t1") }}</h5>
          <span>{{ $t("doc.s1.s2.t2") }}</span>
        </div>
        <div class="section-item">
          <div class="imgitem">
            <img :src="require('@/assets/develop/Board.png')">
          </div>
          <h5>{{ $t("doc.s1.s3.t1") }}</h5>
          <span>{{ $t("doc.s1.s3.t2") }}</span>
        </div>
        <div class="section-item">
          <div class="imgitem">
            <img :src="require('@/assets/develop/Folder.png')">
          </div>
          <h5>{{ $t("doc.s1.s4.t1") }}</h5>
          <span>{{ $t("doc.s1.s4.t2") }}</span>
        </div>
      </div>
    </div>
    <div class="content-container dapp txtcenter fixdapp">
      <h4>{{ $t("doc.s2.h4") }}</h4>
      <div class="section-wrapper">
        <div class="section-item">
          <div class="imgitem">
            <img :src="require('@/assets/develop/Books.png')">
          </div>
          <h5>{{ $t("doc.s2.t1") }}</h5>
        </div>
        <div class="section-item">
          <div class="imgitem">
            <img :src="require('@/assets/develop/Schedule.png')">
          </div>
          <h5>{{ $t("doc.s2.t2") }}</h5>
        </div>
        <div class="section-item">
          <div class="imgitem">
            <img :src="require('@/assets/develop/Interface.png')">
          </div>
          <h5>{{ $t("doc.s2.t3") }}</h5>
        </div>
        <div class="section-item">
          <div class="imgitem">
            <img :src="require('@/assets/develop/Bubble.png')">
          </div>
          <h5>{{ $t("doc.s2.t4") }}</h5>
        </div>
      </div>
    </div>

    <sectionColor color="#ECEAFB" height="372px">
      <div slot="left">
        <div class="righttitle">
          <h3 class="planh3">
            {{ $t("doc.s3.t1") }}
          </h3>
          <p class="planp3">
            {{ $t("doc.s3.t2") }}
          </p>
          <p class="planbtn">
            <myButton custom-type="link" href="http://talk.lambdastorage.com">
              {{ $t("doc.s3.btn") }}
            </myButton>
          </p>
        </div>
      </div>
      <div slot="right">
        <div class="imgcons">
          <img :src="imgbc2" class="img" width="399">
        </div>
      </div>
    </sectionColor>
    <div class=" content-container">
      <div class="cardcon">
        <div class="carditem ">
          <h5>{{ $t("doc.s4.s1.h5") }}</h5>
          <ul class="ullinlk">
            <li>
              <a
                href="http://docs.lambda.im/Lambda-Wallet-Guide/"
                target="_blank"
              >
                {{ $t("doc.s4.s1.t1") }}
              </a>
            </li>
            <li>
              <a
                href="http://docs.lambdastorage.com/Farming-Operation-Guide/"
                target="_blank"
              >
                {{ $t("doc.s4.s1.t3") }}
              </a>
            </li>
          </ul>
        </div>

        <div class="carditem ">
          <h5>{{ $t("doc.s4.s2.h5") }}</h5>
          <ul class="ullinlk">
            <li>
              <a
                href="http://docs.lambdastorage.com/Lambda-Tech-Detail/"
                target="_blank"
              >
                {{ $t("doc.s4.s2.t1") }}
              </a>
            </li>
            <li>
              <a
                href="http://docs.lambdastorage.com/Lambda-PDP-Detail/"
                target="_blank"
              >
                {{ $t("doc.s4.s2.t2") }}
              </a>
            </li>
            <li>
              <a
                href="http://docs.lambdastorage.com/Poly-Mining-Protocol/"
                target="_blank"
              >
                {{ $t("doc.s4.s1.t2") }}
              </a>
            </li>
          </ul>
        </div>

        <div class="carditem ">
          <h5>API</h5>
          <ul class="ullinlk">
            <li>
              <a href="http://docs.lambda.im/Wallet-API/" target="_blank">
                {{ $t("doc.s4.s3.t1") }}
              </a>
            </li>
            <!-- <li>
              <a
                href="http://docs.lambda.im/%E4%B8%BB%E7%BD%91%E6%8E%A5%E5%85%A5%E6%95%99%E7%A8%8B(Validator)/"
                target="_blank"
              >
                开发者文档
              </a>
            </li> -->
            <li>
              <a href="http://docs.lambda.im/S3-Gateway-API/" target="_blank">
                {{ $t("doc.s4.s3.t2") }}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <Joingroup />
  </div>
</template>

<script>
import imgbc2 from "@/assets/42.png";
const developer = require("./developer.js");

export default {
  components: {
    sectionColor: () => import("@/components/SectionColor.vue"),
    Joingroup: () => import("@/components/Joingroup.vue"),
    myButton: () => import("@/components/MyButton.vue")
  },
  data() {
    return {
      imgbc2,
      developer
    };
  }
};
</script>

<style lang="less" scoped>
.txt {
  text-align: center;
  color: #ffff;

  h1,
  h2,
  h3 {
    color: #ffff;
    margin-bottom: 43px;
  }
  .planh2 {
    font-size: 30px;
    margin-bottom: 32px;
  }

  .planp {
    font-size: 26px;
    margin-bottom: 66px;
    font-weight: 500;
    color: rgba(255, 255, 255, 1);
    line-height: 37px;
  }

  .btncon {
    width: 32%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
  }
}
.planp3 {
  font-size: 22px;
  font-weight: 400;
  color: rgba(38, 38, 38, 1);
  line-height: 30px;
}

.center {
  margin: 0 auto;
}
.fixcenter {
  margin-top: 70px;
}

.cardcon {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: flex-start;
  margin: 93px 0px 80px 0px;
}

.carditem {
  width: 32%;
  margin-bottom: 20px;
  text-align: center;
  // margin-bottom: 94px;
  .ant-avatar {
    width: 64px;
    height: 64px;
    line-height: 64px;
  }
  h5 {
    border-bottom: 1px solid #eceafb;
    padding-bottom: 9px;
    text-align: left;
  }
  p {
    font-size: 18px;
    line-height: 24px;
    font-weight: 300;
  }
}

.ullinlk {
  margin: 0;
  padding: 0;
  list-style-position: inside;
  color: #3f4ae1;
  text-align: left;
  a {
    color: #3f4ae1;
    font-size: 18px;
  }
  li {
    line-height: 25px;
    margin-bottom: 20px;
    margin-right: 15px;
  }
}

.joinlamb {
  text-align: center;
  color: white;
  padding-top: 60px;

  .txt2 {
    margin: 0px 10%;
  }
  h3 {
    color: white;
  }
  .num {
    font-size: 30px;
    margin-bottom: 10px;
  }
}

.planbtn {
  padding-top: 20px;
}
.txtcenter {
  text-align: center;
}
.dapp {
  margin-bottom: 80px;

  h3 {
    margin-bottom: 39px;
  }
  h4 {
    margin-bottom: 50px;
  }
}
.dappTitle {
  margin-top: 60px;
  margin-bottom: 39px;
}
.fixdapp {
  margin-bottom: 113px;
}
.bg-box {
  background: #3a43d8;
  width: 100%;
  min-height: 590px;
  padding-top: 65px;
}

.item-warpper {
  justify-content: space-between;
  a {
    padding-top: 16px;
    color: #fff;
    text-decoration: underline;
    cursor: pointer;
    font-size: 18px;
  }
  p {
    font-size: 16px;
    margin-bottom: 16px;
  }
  .number-content {
    font-size: 32px;
    color: #ffffff;
    margin-bottom: 16px;
  }
  span {
    font-size: 24px;
    color: #fff;
  }
}

.mining-title {
  margin-top: 50px;
  justify-content: space-between;
  align-items: center;
  p {
    color: rgba(16, 16, 16, 100);
    font-size: 16px;
    span {
      color: rgba(16, 16, 16, 100);
      font-size: 24px;
      font-family: SourceHanSansSC-bold;
    }
  }
  h6 {
    color: rgba(146, 146, 151, 100);
    font-size: 14px;
  }
}
.mining-content {
  justify-content: space-between;
  align-items: stretch;
  .way1-warpper {
    padding: 35px 25px;
    border-radius: 20px;
    border: 1px solid rgba(187, 187, 187, 100);
    .top-content {
      p {
        margin-bottom: 5px;
        color: rgba(146, 146, 151, 100);
        font-size: 16px;
      }
      img {
        margin-right: 20px;
      }
      .p-box {
        margin: 10px 0;
        // justify-content: space-between;
        align-items: center;
        p {
          color: rgba(16, 16, 16, 100);
          font-size: 22px;
          font-family: SourceHanSansSC-bold;
        }
        .mr-20 {
          margin-right: 20px;
        }
      }
    }
  }
  .way2-warpper {
    padding: 40px 40px 30px 40px;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    border: 1px solid rgba(187, 187, 187, 100);
    border-radius: 20px;
    p {
      color: rgba(16, 16, 16, 100);
      font-size: 24px;
      margin-bottom: 0px;
      font-family: SourceHanSansSC-bold;
    }
    span {
      color: rgba(146, 146, 151, 100);
      font-size: 14px;
    }
  }
}

.work-content {
  margin-top: 50px;
  border-radius: 78px;
  border: 1px solid rgba(187, 187, 187, 100);
  padding: 30px 50px;
  h2 {
    color: rgba(16, 16, 16, 100);
    font-size: 22px;
    margin-bottom: 8px;
    font-weight: 600;
  }
  p {
    color: rgba(16, 16, 16, 100);
    font-size: 22px;
    margin-bottom: 8px;
  }
  .flex-content {
    align-items: center;
    .circle {
      border: 1px solid rgba(187, 187, 187, 100);
      border-radius: 50%;
      margin-right: 30px;
      img {
        width: 96px;
      }
    }
  }
}
.link-item {
  margin-top: 20px;
  display: flex;
  align-items: center;
  a {
    color: rgba(52, 79, 240, 100);
    font-size: 22px;
    font-family: SourceHanSansSC-bold;
    text-decoration: underline;
  }
}

@media (min-width: 501px) {
  .section-wrapper {
    margin-top: 25px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    .section-item {
      width: 20%;
      .imgitem {
        height: 60px;
        img {
          height: 100%;
        }
      }
      h5 {
        margin-top: 25px;
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        // font-weight: 600;
        color: rgba(38, 38, 38, 1);
        line-height: 33px;
      }
      span {
        font-size: 15px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(89, 89, 89, 1);
        line-height: 21px;
      }
    }
  }
  .link-container {
    margin-top: 40px;
    margin-bottom: 100px;
    h3 {
      text-align: center;
      margin-bottom: 60px;
    }
    .link-wrapper {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: space-between;
    }
  }

  .item-warpper {
    display: flex;
    .item-content {
      width: 33%;
      margin-bottom: 40px;
      p {
        margin-bottom: 05px;
      }
    }
  }

  .mining-title {
    display: flex;
  }
  .mining-content {
    display: flex;
    .way1-warpper {
      width: 49%;
      .top-content {
        display: flex;
        img {
          max-width: 80px;
        }
        .p-box {
          width: 410px;
          margin: 10px 0;
          display: flex;
        }
      }
    }
    .way2-warpper {
      display: flex;
      img {
        max-width: 80px;
      }
    }
  }

  .work-content {
    p {
      font-size: 22px;
    }
    .flex-content {
      display: flex;
      .circle {
        width: 99px;
        height: 99px;
      }
    }
  }
  .link-item {
    justify-content: center;
    img {
      max-width: 45px;
    }
  }
}
@media (max-width: 1024px) {
  .mining-title {
    display: block;
    h6 {
      font-size: 16px;
    }
  }
  .mining-content {
    display: block;
    .way1-warpper {
      width: 100%;
      margin-bottom: 30px;
      .top-content {
        display: block;
        img {
          max-width: 60px;
          margin-bottom: 20px;
        }
        .p-box {
          width: 100%;
          margin: 20px 0;
          display: block;
        }
      }
    }
    .way2-warpper {
      padding: 40px 40px 30px 40px;
      width: 100%;
      display: block;
      align-items: center;
      justify-content: space-between;
      border: 1px solid rgba(187, 187, 187, 100);
      border-radius: 20px;
      p {
        color: rgba(16, 16, 16, 100);
        font-size: 24px;
        margin-bottom: 0px;
      }
      span {
        color: rgba(146, 146, 151, 100);
        font-size: 14px;
      }
      img {
        max-width: 80px;
      }
    }
  }
}
@media (max-width: 500px) {
  .section-item {
    margin-bottom: 60px;
    h5 {
      margin-top: 10px;
    }
  }
  .link-container {
    margin-top: 40px;
    h3 {
      text-align: center;
      margin-bottom: 25px;
    }
    .link-wrapper {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: space-between;
      .link-button {
        text-align: center;
        width: 100%;
        margin-bottom: 20px;
      }
    }
  }
  .carditem {
    width: 100%;
  }
  .imgitem {
    margin-bottom: 30px;
  }

  .txt {
    margin-left: 5%;
    margin-right: 5%;

    .planh1 {
      font-size: 32px;
      line-height: 45px;
      margin-bottom: 30px;
    }
    .planp {
      font-size: 20px;
      line-height: 20px;
      margin-bottom: 44px;
    }
  }

  .righttitle {
    text-align: center;
    min-height: 140px;
    padding-top: 63px;
    .planh1 {
      margin-bottom: 21px;
    }
    .planp3 {
      margin-left: 5%;
      margin-right: 5%;
    }
  }

  .imgcons {
    text-align: center;
  }

  .center {
    margin: auto;
  }
  .bg-box {
    min-height: 660px;
    padding-top: 20px;
  }

  .item-warpper {
    display: block;
    .item-content {
      // width: 33%;
      margin-bottom: 40px;
      p {
        margin-bottom: 05px;
      }
    }
  }

  .mining-title {
    display: block;
    h6 {
      font-size: 16px;
    }
  }
  .mining-content {
    display: block;
    .way1-warpper {
      width: 100%;
      margin-bottom: 30px;
      .top-content {
        display: block;
        img {
          max-width: 60px;
          margin-bottom: 20px;
        }
        .p-box {
          width: 100%;
          margin: 20px 0;
          display: block;
        }
      }
    }
    .way2-warpper {
      padding: 40px 40px 30px 40px;
      width: 100%;
      display: block;
      align-items: center;
      justify-content: space-between;
      border: 1px solid rgba(187, 187, 187, 100);
      border-radius: 20px;
      p {
        color: rgba(16, 16, 16, 100);
        font-size: 24px;
        margin-bottom: 0px;
      }
      span {
        color: rgba(146, 146, 151, 100);
        font-size: 14px;
      }
      img {
        max-width: 80px;
      }
    }
  }

  .work-content {
    .flex-content {
      display: block;
      .circle {
        width: 69px;
        height: 69px;
        img {
          width: 66px;
        }
      }
    }
  }
  .link-item {
    justify-content: start;
    a {
      font-size: 20px;
    }
    img {
      max-width: 30px;
    }
  }
  .nbsp {
    height: 0;
  }
}
</style>
